.statCard {
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: stretch;
  border-radius: 0.75rem;
  border: 1px solid var(--static-divider-standard);
  background: var(--static-background-standard);
  color: var(--static-text-standard);
  transition: all 300ms;
}

.statCardHeader {
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--static-divider-standard);
}

.statCardHeader h3 {
  font-size: var(--fs-small);
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.3125rem;
}

.statCardInfo {
  display: grid;
  place-items: center;
}

.statCardData {
  margin-top: 1rem;
}

.statCardData h4 {
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2rem;
  color: var(--static-text-strong);
}

.statCardContent {
  padding-top: 1rem;
}

.statCardList {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.statCardListItem {
  font-size: var(--fs-small);
  line-height: 1.25rem;
  display: flex;
  justify-content: space-between;
}

.statCardListItem span {
  font-weight: 500;
  color: var(--static-text-strong);
}